<template>
  <div class="detailsBoxInfo">
    <h2 v-if="title"
        class="detailsBoxInfo_title">
      {{ title }}
    </h2>
    <p v-if="text"
       class="detailsBoxInfo_text text-uppercase">
      {{ text }}
    </p>
  </div>
</template>

<script>
  export default {
    name: "DetailsBoxInfo",
    props: [ 'text', 'title' ]
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .detailsBoxInfo {
    line-height: pxToRem(16);

    &_title,
    &_text {
      font-size: pxToRem(14);
      margin-bottom: pxToRem(4);
    }

    &_title {
      border-bottom: pxToRem(1) solid;
      display: inline-block;
    }

    &_text {}
  }
</style>
